export default "__VITE_PUBLIC_ASSET__3d89ccbf__"